/*
 * Keeöz — barre d'achat collante.
 * Pas de formulaire propre : le bouton clique sur le vrai bouton d'achat de la fiche.
 * Visible quand ce bouton est sorti de l'écran par le haut, jusqu'en bas de page (footer compris).
 * Synchronisée dans les deux sens avec le sélecteur de variantes et, sur la taie, avec les offres
 * groupées (snippets/taie-offer.liquid : cartes [data-taie-offer-card], sélection = .is-selected).
 */
(() => {
  if (window.KeeozStickyATC) return;
  window.KeeozStickyATC = true;

  const init = (bar) => {
    if (bar.dataset.kzReady) return;
    bar.dataset.kzReady = 'true';

    const sectionId = bar.dataset.sectionId;
    const mainButton = document.getElementById(`x-atc-button-${sectionId}`);
    if (!mainButton) return;

    // Sortie du conteneur du bloc : un ancêtre transformé casserait le position: fixed.
    document.body.appendChild(bar);

    const button = bar.querySelector('[data-kz-sticky-add]');
    let priceEl = bar.querySelector('[data-kz-sticky-price]');
    const selectEl = bar.querySelector('[data-kz-sticky-select]');
    const imageEl = bar.querySelector('.kz-sticky__img');
    let variants = [];
    try {
      variants = JSON.parse(bar.querySelector('[data-kz-sticky-variants]').textContent);
    } catch (error) {
      variants = [];
    }

    let pastButton = false;
    let shown = null;

    const render = () => {
      const visible = pastButton;
      if (visible === shown) return;
      shown = visible;
      bar.classList.toggle('is-visible', visible);
      document.body.classList.toggle('kz-sticky-open', visible);
      if (visible) document.body.style.setProperty('--kz-sticky-height', `${bar.offsetHeight}px`);
      if (visible) {
        bar.removeAttribute('inert');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.setAttribute('inert', '');
        bar.setAttribute('aria-hidden', 'true');
      }
    };

    // Offres groupées de la taie : pastilles dans la barre, miroir des cartes de la fiche.
    const offerBox = document.querySelector(`[data-taie-offer][data-section-id="${sectionId}"]`);
    const offerCards = offerBox ? [...offerBox.querySelectorAll('[data-taie-offer-card]')] : [];
    const offerChips = [];

    const syncOffers = () => {
      let selected = null;
      offerCards.forEach((card, index) => {
        const active = card.classList.contains('is-selected');
        offerChips[index].classList.toggle('is-active', active);
        offerChips[index].setAttribute('aria-pressed', String(active));
        if (active) selected = card;
      });
      const offerPrice = selected && selected.querySelector('.taie-offer__current');
      if (priceEl && offerPrice) priceEl.textContent = offerPrice.textContent.trim();
    };

    if (offerCards.length) {
      const wrap = document.createElement('div');
      wrap.className = 'kz-sticky__offers';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', 'Offres');
      offerCards.forEach((card) => {
        const label =
          (card.querySelector('.taie-offer__quantity') || card.querySelector('.taie-offer__title') || {}).textContent ||
          card.dataset.quantity;
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'kz-sticky__offer';
        chip.textContent = label.trim();
        chip.addEventListener('click', () => card.click()); // la fiche reste maîtresse de la quantité
        offerChips.push(chip);
        wrap.appendChild(chip);
      });
      bar.querySelector('[data-kz-sticky-options]').appendChild(wrap);

      // Prix de l'offre affiché même si le prix variante est masqué (réglage du bloc).
      if (!priceEl) {
        priceEl = document.createElement('span');
        priceEl.className = 'kz-sticky__price';
        bar.querySelector('.kz-sticky__meta').appendChild(priceEl);
      }

      const observer = new MutationObserver(syncOffers);
      offerCards.forEach((card) => observer.observe(card, { attributes: true, attributeFilter: ['class'] }));
      syncOffers();
    }

    // Sans offres groupées, la liste de variantes remonte à côté du prix : barre sur une seule ligne.
    if (!offerCards.length && selectEl) {
      const meta = bar.querySelector('.kz-sticky__meta');
      meta.insertBefore(selectEl, meta.firstChild);
      bar.classList.add('kz-sticky--inline');
    }

    // image_tag génère un srcset prioritaire sur src : on le retire pour que le changement se voie.
    const setImage = (variant) => {
      if (!imageEl || !variant.image) return;
      imageEl.removeAttribute('srcset');
      imageEl.removeAttribute('sizes');
      imageEl.src = variant.image;
    };

    const syncVariant = () => {
      const input = document.querySelector(`#${bar.dataset.formId} input[name="id"]`);
      const variant = input && variants.find((item) => String(item.id) === String(input.value));
      if (variant) {
        if (priceEl && !offerCards.length) priceEl.textContent = variant.price;
        if (selectEl && selectEl.value !== String(variant.id)) selectEl.value = String(variant.id);
        setImage(variant);
      }
      const soldOut = mainButton.disabled || (variant && !variant.available);
      button.disabled = soldOut;
      button.textContent = soldOut ? bar.dataset.soldOutLabel : bar.dataset.buttonLabel;
    };

    // Visibilité calculée sur la position réelle, avec hystérésis : un petit scroll vers le haut
    // (réapparition du header « on scroll up », barre d'adresse mobile…) ne doit pas la masquer.
    const SHOW_AFTER = 0; // le bas du bouton principal est passé au-dessus du haut de l'écran
    const HIDE_BEFORE = 120; // le bouton est revenu nettement dans l'écran (px sous le haut)
    let ticking = false;

    const update = () => {
      ticking = false;
      const rect = mainButton.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) return; // bouton masqué (rendu en cours) : on ne change rien
      if (!pastButton && rect.bottom < SHOW_AFTER) pastButton = true;
      else if (pastButton && rect.top > HIDE_BEFORE) pastButton = false;

      render();
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    // Variante, disponibilité, état du bouton principal (désactivé, chargement…).
    document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, () => setTimeout(syncVariant, 50));
    new MutationObserver(syncVariant).observe(mainButton, { attributes: true, attributeFilter: ['disabled'] });

    // Barre → fiche : on pilote le sélecteur de variantes de la fiche, qui met à jour URL, prix,
    // médias, formulaire… puis revient vers la barre via l'événement de variante.
    const selectMainVariant = (variant) => {
      let changed = null;
      (variant.options || []).forEach((value, index) => {
        const control = document.getElementById(`Option-${sectionId}-${index}`);
        if (!control) return;
        if (control.tagName === 'SELECT') {
          if (control.value !== value) {
            control.value = value;
            changed = control;
          }
        } else {
          const radio = [...control.querySelectorAll('input[type="radio"]')].find((input) => input.value === value);
          if (radio && !radio.checked) {
            radio.checked = true;
            changed = radio;
          }
        }
      });
      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
    };

    if (selectEl) {
      selectEl.addEventListener('change', () => {
        const variant = variants.find((item) => String(item.id) === selectEl.value);
        if (!variant) return;
        if (priceEl && !offerCards.length) priceEl.textContent = variant.price;
        setImage(variant);
        selectMainVariant(variant);
      });
    }

    button.addEventListener('click', () => {
      if (mainButton.disabled) return;
      mainButton.click();
    });

    syncVariant();
  };

  const initAll = () => document.querySelectorAll('[data-kz-sticky]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
